import React, { useEffect, useRef, useState } from "react";
import "./ChatWindow.css";
import * as chatService from "../../../../../../service-layer/ChatService";
import PropTypes from "prop-types";
import { getStaffId } from "../../../../../../axios/CurrentMedicalStaffManager";
import { useTranslation } from "react-i18next";
import { FaPaperPlane } from "react-icons/fa";
import LogoutModal from "../../../../../components/logout-moal/LogoutModal";
import { useNavigate } from "react-router-dom";

import { useStateContext } from "../../../../../../contextProvider";

const ChatWindow = ({
  chat,
  newMessage,
  setNewMessage,
  setMessageSent,
  medicalStaffId,
  patientId,
}) => {
  const textareaRef = useRef(null);
  const messagesRef = useRef(null);
  const { t } = useTranslation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  const { selectedPatient, setSelectedPatient, selectedPatientData, 
    setSelectedPatientData, doctorPage, setDoctorPage } = useStateContext()

  const handleConfirm = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("name");
    localStorage.removeItem("surname");
    localStorage.removeItem("authority");

    localStorage.removeItem("doctor_page");
    localStorage.removeItem("patient_id");
    localStorage.removeItem("staff_id");
    localStorage.removeItem("patient_data");

    setSelectedPatient(undefined)
    setSelectedPatientData(undefined)
    setDoctorPage(undefined)

    setShowLogoutModal(false);
    navigate("/");
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    textarea.style.height = "auto";
  }, [newMessage]);

  useEffect(() => {
    scrollToBottom();
  }, [chat]);

  const scrollToBottom = () => {
    const messages = messagesRef.current;
    messages.scrollTop = messages.scrollHeight;
  };
  const handleSend = async () => {
    if (newMessage.trim()) {
      const messagePayload = {
        userId: patientId,
        medicalStaffId: getStaffId(),
        messagePayload: newMessage,
        messageTimestamp: new Date().toISOString(),
      };

      await chatService.postNewMessage(messagePayload);
      setNewMessage("");
      setMessageSent(true);

      // Reset the textarea rows to 1 when the message is sent
      const textarea = textareaRef.current;
      textarea.rows = 1;
      textarea.style.overflowY = "hidden"; // Hide scrollbar if present
    }
  };

  const renderMessagesByDay = () => {
    const groupedMessages = groupMessagesByDay(chat);
    return groupedMessages.map((group, index) => (
      <div key={index}>
        <div className="message-date">{formatDate(group.date)}</div>
        {group.messages.map((message, idx) => (
          <div key={idx} className="message-container">
            <div className="message">
              <div className="message-content">{message.messagePayload}</div>
              <div className="timestamp">
                {new Date(message.messageTimestamp).toLocaleTimeString(t('volte') === 'volte' ? 'it-IT' : 'en-EN', {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
    ));
  };

  const groupMessagesByDay = (messages) => {
    const groupedMessages = [];
    //messages in Rome timezone
    const new_messages = messages.map(m => {

      const timestamp = m.messageTimestamp
      let date_timestamp = new Date(timestamp)

      const romeOffset =  - new Date(
        date_timestamp.toLocaleString("en-US", { timeZone: "Europe/Rome" })
      ).getTimezoneOffset();
    
      console.log("OFFEST", romeOffset)
      const romeOffsetInHours = romeOffset / 60;

      const new_timestamp = new Date(m.messageTimestamp)
      new_timestamp.setHours(date_timestamp.getHours() + romeOffsetInHours)

      const year = new_timestamp.getFullYear();
      const month = String(new_timestamp.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(new_timestamp.getDate()).padStart(2, "0");
      const hours = String(new_timestamp.getHours()).padStart(2, "0");
      const minutes = String(new_timestamp.getMinutes()).padStart(2, "0");
      const seconds = String(new_timestamp.getSeconds()).padStart(2, "0");
      const milliseconds = String(new_timestamp.getMilliseconds()).padStart(2, "3").substring(0, 2); // Truncate to 2 digits

  // Construct the desired format
      const string_timestamp = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;

      return {...m, messageTimestamp: string_timestamp}
    })


    const uniqueDates = new_messages
      .map((m) => new Date(m.messageTimestamp).toLocaleDateString("en-GB"))
      .filter((val, ind, arr) => arr.indexOf(val) === ind);


    uniqueDates.forEach((val) => {
      const dateMessages = new_messages.filter((m) => {
        const date = new Date(m.messageTimestamp).toLocaleDateString("en-GB");
        return date === val;
      });

      if (dateMessages.length > 0) {
        groupedMessages.push({
          date: val,
          messages: dateMessages,
        });
      }
    });

    return groupedMessages;
  };

  const formatDate = (dateString) => {
    const [day, month, year] = dateString.split("/");
    const adjustedDateString = `${month}/${day}/${year}`;

    const date = new Date(adjustedDateString);
    // return t('volte') === 'volte' ? `${day}/${month}/${year}` : `${month}/${day}/${year}`;
    return `${day}/${month}/${year}`;
  };

  const handleTextareaResize = (e) => {
    const textarea = e.target;
    textarea.rows = 1; // Reset rows to 1 so it shrinks when deleting text
    const lineHeight = 24; // Set an estimated line height (you can adjust it based on your styles)
    const maxRows = 2;

    const currentRows = Math.floor(textarea.scrollHeight / lineHeight);

    if (currentRows >= maxRows) {
      textarea.rows = maxRows;
      textarea.style.overflowY = "scroll"; // Start scrolling once max rows is reached
    } else {
      textarea.rows = currentRows; // Adjust rows dynamically
      textarea.style.overflowY = "hidden"; // Hide the scrollbar until max rows is reached
    }
  };

  return (
    <>
      <div className="chat-window">
        <div className="messages" ref={messagesRef}>
          {renderMessagesByDay()}
        </div>
        <div className="input-container">
          <div className="input-inner-container">
            <div style={{ width: "100%", marginRight: "5px" }}>
              <textarea
                ref={textareaRef}
                value={newMessage}
                onChange={(e) => {
                  setNewMessage(e.target.value);
                  handleTextareaResize(e);
                }}
                placeholder={t("typeMessage")}
                rows={1}
                style={{ resize: "none", overflowY: "auto" }}
              />
            </div>
            <FaPaperPlane
              size={40}
              className="send-icon"
              onClick={handleSend}
            />
          </div>
        </div>
      </div>
      <LogoutModal
        show={showLogoutModal}
        handleConfirm={handleConfirm}
        handleClose={handleConfirm}
        title={t("login")}
        message={t("session_expired_please_login_again")}
        tag={"Login"}
      />
    </>
  );
};

ChatWindow.propTypes = {
  chat: PropTypes.arrayOf(
    PropTypes.shape({
      messagePayload: PropTypes.string,
      messageTimestamp: PropTypes.string,
    }),
  ),
  newMessage: PropTypes.string,
  setNewMessage: PropTypes.func,
  medicalStaffId: PropTypes.number,
  patientId: PropTypes.number,
};

export default ChatWindow;
